import * as React from "react";
import { getCurrentLanguage, Language } from "@cak-legacy/shared-locales";
import { translate } from "../Locales/translator";

export interface IBedanktPaginaProps {
  klantContactId?: number;
  titel?: string;
  bericht?: {
    tekst: string;
    overrideVertaling?: boolean;
  };
  toonMeldingNoteerNummerNaVerzending: boolean;
  overrideHomePageUrl?: string;
}

export const BedanktPagina = (props: IBedanktPaginaProps) => {
  const language = getCurrentLanguage();
  return (
    <>
      {props.titel && (
        <div className="pt-4 intro">
          <h1>{props.titel}</h1>
        </div>
      )}
      <div className="bedankt-container">
        <p>
          {props.bericht && (language === Language.Nederlands || props.bericht.overrideVertaling === true)
            ? props.bericht.tekst
            : translate("BedanktBericht", { klantContactId: props.klantContactId?.toString() ?? "" })}
          <br />
          <br />
          {props.toonMeldingNoteerNummerNaVerzending && translate("MeldingNoteerNummerNaVerzending")}
        </p>
        <div className="formbutton-container">
          <a className="btn btn--primary" href={props.overrideHomePageUrl ?? "https://www.hetcak.nl"}>
            {translate("NaarOnzeHomepage")}
          </a>
        </div>
      </div>
    </>
  );
};
